import PengaturanAplikasi from "pages/v1/system-setting/pengaturan-aplikasi";
// Modules
import { URLS } from "utils/constants";
import { createBrowserRouter } from "react-router-dom";

// Middlewares
import ProtectedRoute from "middleware/ProtectedRoute";

// Components
import { authRouter } from "./auth";
import NotFound from "components/not-found";
import TeamsPage from "pages/v1/teams/teams-page";
import RolesPage from "pages/v1/roles/roles-page";
import PermissionsPage from "pages/v1/permissions/permissions-page";
import ProfilePage from "pages/v1/profile/profile-page";
import ChangePassword from "pages/v1/profile/change-password";
import General from "pages/v1/system-setting/general";
import NotifChannel from "pages/v1/system-setting/notif-channel";
import PaymentGateway from "pages/v1/system-setting/payment-gateway";
import InvoicePage from "pages/v1/invoices/invoices-page";
import InvoiceCreatePage from "pages/v1/invoices/invoice-create-page";
import InvoiceViewPage from "pages/v1/invoices/invoice-view-page";
import DiscountPage from "pages/v1/discounts/discounts-page";
import InvoicePublicViewPage from "pages/v1/invoices/invoice-public-page";
import InvoicesHistoryPage from "pages/v1/invoice-history/Invoice-history-page";
import BankAccounts from "pages/v1/system-setting/bank-accounts";
import TemplateMessage from "pages/v1/system-setting/message-invoice";
import NotAuthorized from "components/NotAuthorized";
import AttendanceCheckPage from "pages/public/attendance-check-page";

// Contexts Providers
import { AuthProvider } from "contexts/AuthContext";
import { CanvasProvider } from "contexts/canvas-context";
import { InvoiceProvider } from "contexts/v1/pages/InvoiceContext";
import { InvoiceCreateProvider } from "contexts/v1/pages/InvoiceCreateContext";
import { InvoiceViewProvider } from "contexts/v1/pages/InvoiceViewContext";
import { DiscountProvider } from "contexts/v1/pages/DiscountContext";
import { InvoiceHistoryProvider } from "contexts/v1/pages/InvoiceHistoryContext";
import { BankAccountProvider } from "contexts/v1/pages/BankAccountContext";
import { NotifChannelProvider } from "contexts/v1/pages/NotifChannelContext";
import { MessageInvoiceProvider } from "contexts/v1/pages/MessageInvoiceContex";
import { TripProvider } from "contexts/v1/masterData/TripContext";
// import { BookingProviderV3 } from "contexts/v3/BookingContextV3";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { restoRoutes } from "./core/resto-routes";
import { bookingRoutes } from "./core/booking-routes";
import { agentRankRoutes } from "./core/agent-rank-routes";
import { workshopRoutes } from "./core/workshop-routes";
import { hrRoutes } from "./core/hr-routes";

const queryClient = new QueryClient(); // ✅ Inisialisasi QueryClient

export const router = createBrowserRouter([
  {
    path: URLS.ROOT,
    element: (
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          {" "}
          {/* ✅ Bungkus aplikasi dengan provider */}
          <CanvasProvider>
            <TripProvider>
              {/* <BookingProviderV3> */}
              <ProtectedRoute />
              {/* </BookingProviderV3> */}
            </TripProvider>
          </CanvasProvider>
        </QueryClientProvider>
      </AuthProvider>
    ),
    children: [
      ...restoRoutes,
      ...bookingRoutes,
      ...agentRankRoutes,
      ...workshopRoutes,
      ...hrRoutes,

      {
        path: URLS.v1.INVOICES,
        element: (
          <InvoiceProvider>
            <InvoicePage />
          </InvoiceProvider>
        ),
      },
      {
        path: URLS.v1.INVOICES_CREATE,
        element: (
          <InvoiceCreateProvider>
            <InvoiceCreatePage />
          </InvoiceCreateProvider>
        ),
      },
      {
        path: URLS.v1.INVOICES_VIEW,
        element: (
          <InvoiceCreateProvider>
            <InvoiceViewPage />
          </InvoiceCreateProvider>
        ),
      },
      {
        path: URLS.v1.INVOICES_EDIT,
        element: (
          <InvoiceCreateProvider>
            <InvoiceCreatePage />
          </InvoiceCreateProvider>
        ),
      },
      {
        path: URLS.v1.INVOICES_HISTORY,
        element: (
          <InvoiceHistoryProvider>
            <InvoicesHistoryPage />
          </InvoiceHistoryProvider>
        ),
      },
      {
        path: URLS.v1.INVOICES_HISTORY_BY_ID,
        element: (
          <InvoiceHistoryProvider>
            <InvoicesHistoryPage />
          </InvoiceHistoryProvider>
        ),
      },
      {
        path: URLS.v1.DISCOUNT,
        element: (
          <DiscountProvider>
            <DiscountPage />
          </DiscountProvider>
        ),
      },
      {
        path: URLS.v1.TEAMS,
        element: <TeamsPage />,
      },
      {
        path: URLS.v1.ROLES,
        element: <RolesPage />,
      },
      {
        path: URLS.v1.PERMISSIONS,
        element: <PermissionsPage />,
      },
      {
        path: URLS.v1.PROFILE,
        element: <ProfilePage />,
      },
      {
        path: URLS.v1.CHANGE_PASSWORD,
        element: <ChangePassword />,
      },
      {
        path: URLS.v1.SYSTEM_SETTING,
        element: <General />,
      },
      // General, Notif Channel, Payment Gateway
      {
        path: URLS.v1.GENERAL,
        element: <General />,
      },
      {
        path: URLS.v1.NOTIF_CHANNEL,
        element: (
          <NotifChannelProvider>
            {/* <MailTargetProvider> */}
            <NotifChannel />
            {/* </MailTargetProvider> */}
          </NotifChannelProvider>
        ),
      },
      {
        path: URLS.v1.PAYMENT_GATEWAY,
        element: <PaymentGateway />,
      },
      {
        path: URLS.v1.BANK_ACCOUNT,
        element: (
          <BankAccountProvider>
            <BankAccounts />
          </BankAccountProvider>
        ),
      },
      // template message
      {
        path: URLS.v1.TEMPLATE_MESSAGE,
        element: (
          <MessageInvoiceProvider>
            <TemplateMessage />
          </MessageInvoiceProvider>
        ),
      },
      {
        path: URLS.v1.NOTAUTHORIZED,
        element: <NotAuthorized />,
      },
      {
        path: URLS.v1.PENGATURAN_APLIKASI,
        element: <PengaturanAplikasi />,
      },
    ],
    errorElement: <NotFound />,
  },
  ...authRouter,
  {
    path: URLS.INVOICES_PUBLIC_VIEW,
    element: (
      <InvoiceViewProvider>
        <InvoicePublicViewPage />
      </InvoiceViewProvider>
    ),
  },
  {
    path: "/attendance-check",
    element: (
      <AuthProvider>
        <CanvasProvider>
          <AttendanceCheckPage />
        </CanvasProvider>
      </AuthProvider>
    ),
  },
]);
